import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IConfig } from "../model/IConfig";
import { IUser } from "../model/IUser";

export interface IAuthState {
  config: IConfig | null;
  user: IUser | null; 
}

const initState = {
  config: null, user: null
} as IAuthState

const authSlice = createSlice({
  name: 'auth',
  initialState: initState as IAuthState,
  reducers: {
    configSet: (
      state,
      action: PayloadAction<IConfig>
    ): IAuthState => {
      return {
        ...state,
        config: action.payload
      }
    },  
    userSet: (
      state,
      action: PayloadAction<IUser | null>
    ): IAuthState => {
      return {
        ...state,
        user: action.payload
      }
    }  
  },
  selectors: {
    selectConfig: (state) => state.config
  }
})


export const {
  selectConfig
} = authSlice.selectors;

export const {
  userSet, 
  configSet
} = authSlice.actions

export default authSlice.reducer

